<template>
  <div class="value">
    <div
      v-if="hasValue"
      :style="[uppercase ? { 'text-transform': 'uppercase' } : '']"
    >
      <span v-if="currency">{{ valueToCurrency }}</span>
      <span v-else>{{ value }}</span>
    </div>
    <span v-else>---</span>
  </div>
</template>

<script>
import { toCurrency } from '@/utils/toCurrency';

export default {
  name: 'CreditWidgetValue',
  props: {
    value: {
      type: [String, Number],
      default: undefined,
    },
    currency: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasValue() {
      return this.value !== undefined && this.value !== null;
    },
    valueToCurrency() {
      return toCurrency(this.value);
    },
  },
};
</script>
